import React, { useState } from "react";
import { toast } from "react-toastify";
import { Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import Tooltip from "Components/Common/Tooltip";
import { DocumentName } from "Components/RegisterBuildingForm/FireProtection/style";
import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";
import Collapse from "./Collapse";

import { getImageUrl } from "utils";
import getFileExtension from "utils/getFileExtension";
import removeExtension from "utils/removeExtension";

import pdfImg from "assets/images/pdf.png";

const docFormats = ["doc", "docx"];

const CGRFDocumentsViewModal = ({ documents, isExpandable = true }) => {
  const [documentToPreview, setDocumentToPreview] = useState();

  const previewButtonHandler = (documentName, documentURL) => {
    const fileExtension = getFileExtension(documentName ?? "");
    const documentUrl = getImageUrl(documentURL ?? "");

    if (docFormats.includes(fileExtension?.toLowerCase())) {
      toast.success("Document downloaded successfully");
    } else {
      setDocumentToPreview({
        documentTypeName: "",
        documentUrl,
        documentType: fileExtension,
        documentName: removeExtension(documentName ?? ""),
      });
    }
  };

  return (
    <>
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          {...documentToPreview}
        />
      )}

      {!!documents?.length && (
        <Collapse title="Documents" isExpandable={isExpandable}>
          <Row className="d-flex gap-3 flex-wrap">
            {documents.map(({ documentUrl, documentName }, index) => (
              <div className="image-container" key={index}>
                <a
                  onClick={() =>
                    previewButtonHandler(documentName, documentUrl)
                  }
                >
                  <Box
                    component="img"
                    className="image d-block m-auto cursor-pointer"
                    alt="document image"
                    src={
                      getFileExtension(
                        (documentUrl
                          ? documentUrl
                          : documentName
                        )?.toLowerCase()
                      ) === "pdf"
                        ? pdfImg
                        : getImageUrl(documentUrl)
                    }
                  />
                </a>
                <Tooltip title={documentName}>
                  <DocumentName fontSize={13} variant="body2">
                    {documentName}
                  </DocumentName>
                </Tooltip>
              </div>
            ))}
          </Row>
        </Collapse>
      )}
    </>
  );
};

CGRFDocumentsViewModal.propTypes = {
  documents: PropTypes.array,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(CGRFDocumentsViewModal);
